var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcomeBox"},[_c('vue-typer',{attrs:{"erase-style":"select-all","caret-animation":"expand","initial-action":"typing","text":_vm.vueTyperText,"repeat":Infinity,"shuffle":false,"pre-type-delay":36,"type-delay":100,"pre-erase-delay":2000,"erase-delay":500,"erase-on-complete":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }